<template>
    <div class="poster">
        <div class="title">
            <p>市场预警</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.id" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="product_id">
                        <el-select v-model="formInline.product_id" placeholder="请选择品牌名称" @change="getList">
                            <el-option label="全部" :value="0"> </el-option>
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.goods_name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="竞品预警" name="0">
                        <div slot="label">
                            <el-badge :value="unread_count" class="item" :hidden="unread_count <= 0"> 竞品预警 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="竞品列表" name="1"></el-tab-pane>
                </el-tabs>
                <div class="btnlist" v-show="activeName == 1">
                    <el-button type="primary" size="medium" @click="showAddProduct()">+ 添加品牌</el-button>
                    <el-button type="primary" size="medium" @click="showAddGoods()">+ 添加商品</el-button>
                </div>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload" v-if="activeName == 0">
                    <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="type" label="预警类型" align="center">
                        <template slot-scope="scope">
                            <div class="dot">
                                <el-badge is-dot class="item" :hidden="scope.row.is_read == 1">竞品预警</el-badge>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="brand_name" label="品牌名称" align="center"> </el-table-column>
                    <el-table-column prop="platform_name" label="平台" align="center"> </el-table-column>
                    <el-table-column prop="product_name" label="商品名称" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.product_name && scope.row.product_name.length > 10" :content="scope.row.product_name" placement="top" effect="light">
                                <span>{{ scope.row.product_name | strFmt }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.product_name | strFmt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="预警时间" align="center"> </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="detailList(scope.row)">详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table :data="tableData" style="width: 100%" v-loading="tabload" v-if="activeName == 1">
                    <el-table-column prop="id" label="竞品ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="brand_name" label="品牌名称" align="center"> </el-table-column>
                    <el-table-column prop="plateform_list" label="监控平台" align="center">
                        <template slot-scope="scope">
                            <p>{{ scope.row.plateform_list | arrFmt }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="商品名称" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.name && scope.row.name.length > 10" :content="scope.row.name" placement="top" effect="light">
                                <span>{{ scope.row.name | strFmt }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.name | strFmt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_time" label="最近操作时间" align="center"> </el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                        <template slot-scope="scope">
                            <p>{{ scope.row.status == 1 ? "开启" : "暂停" }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right" width="200px">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link :type="scope.row.status == 1 ? 'danger' : 'success'" @click="updateStatus(scope.row.id, scope.row.status)">{{
                                    scope.row.status == 1 ? "暂停" : "启动"
                                }}</el-link>
                                <el-link type="primary" @click="detail(scope.row.id)">详情</el-link>
                                <el-link type="warning" @click="editGoods(scope.row)">编辑</el-link>
                                <el-link type="danger" @click="deleteProduct(scope.row.id)">删除</el-link>
                                <el-link @click="createPlatform(scope.row.id)">添加平台</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <CreateBrand ref="refCreateBrand" @initProduct="getCompeteBrandList" @init="getList"></CreateBrand>
        <Detail ref="refDetail"></Detail>
        <DetailDataList ref="refDetailDataList"></DetailDataList>
        <CreateOrEditGoods ref="refCreateOrEditGoods" :options="options" @init="getList"></CreateOrEditGoods>
        <CreatePlatform ref="refCreatePlatform" @init="getList" :platformList="platformList"></CreatePlatform>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CreatePlatform from "@/components/Modules/MarketWarn/CreatePlatform.vue";
import CreateBrand from "@/components/Modules/MarketWarn/CreateBrand.vue";
import CreateOrEditGoods from "@/components/Modules/MarketWarn/CreateOrEditGoods.vue";
import Detail from "@/components/Modules/MarketWarn/Detail.vue";
import DetailDataList from "@/components/Modules/MarketWarn/DetailDataList.vue";

export default {
    components: {
        CreateBrand,
        Detail,
        CreateOrEditGoods,
        CreatePlatform,
        DetailDataList,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            formInline: {
                id: "",
                product_id: "",
                goods_name: "",
            },
            activeName: "0",
            options: [],
            platformList: [],
            unread_count: 0,
        };
    },
    filters: {
        arrFmt(val) {
            if (val && val.length > 0) {
                let arr = val.map((item) => {
                    return item.plateform_name;
                });
                return arr.toString();
            }
            return "-";
        },
        strFmt(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 10) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
        this.getCompeteBrandList();
        this.getPlatformList();
        this.getReadCount();
    },
    methods: {
        ...mapActions({
            competeBrand: "brand/competeBrand", //品牌下拉
            competeProduct: "brand/competeProduct", //竞品列表
            updateStatusCompeteProduct: "brand/updateStatusCompeteProduct", //竞品列表状态修改
            deleteCompeteProduct: "brand/deleteCompeteProduct", //竞品列表删除
            getPlatform: "brand/getPlatform", //获取平台下拉
            getReporCompeteProduct: "brand/getReporCompeteProduct", //竞品预警
        }),
        // 获取平台下拉列表
        getPlatformList() {
            let parmas = {
                token: this.getToken,
                ids: "1,2,3",
                page: 0,
                size: 0,
            };
            this.getPlatform(parmas).then(({ data }) => {
                if (data.code == 1) {
                    this.platformList = data.data.list;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        detailList(row) {
            if (row.is_read == 0) {
                row.is_read = 1;
                this.unread_count -= 1;
            }
            this.$refs.refDetailDataList.dialogVisible = true;
            this.$refs.refDetailDataList.getInfo(row.id);
        },
        // 详情
        detail(id) {
            this.$refs.refDetail.dialogVisible = true;
            this.$refs.refDetail.getInfo(id);
        },
        // 删除竞品列表数据
        deleteProduct(id) {
            this.$confirm("是否确认删除此数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        id: id,
                        token: this.getToken,
                    };
                    this.deleteCompeteProduct(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 竞品列表状态更新
        updateStatus(id, status) {
            let params = {
                token: this.getToken,
                id: id,
                status: status == 1 ? 2 : 1,
            };
            this.updateStatusCompeteProduct(params).then(({ data }) => {
                if (data.code == 1) {
                    this.$message.success("修改成功！");
                    this.getList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 品牌下拉
        async getCompeteBrandList() {
            let params = {
                token: this.getToken,
                page: 0,
                size: 0,
            };
            let { data } = await this.competeBrand(params);
            if (data.code == 1) {
                this.options = data.data.list;
            } else {
                this.$message.error(data.msg);
            }
        },
        // 添加平台
        createPlatform(id) {
            this.$refs.refCreatePlatform.dialogVisible = true;
            this.$refs.refCreatePlatform.compete_product_id = id;
            this.$refs.refCreatePlatform.getPlatformList(0);
        },
        // 编辑竞品列表内容
        editGoods(row) {
            this.$refs.refCreateOrEditGoods.dialogVisible = true;
            this.$refs.refCreateOrEditGoods.editId = row.id;
            this.$refs.refCreateOrEditGoods.formInline = row;
        },
        // 显示添加商品弹窗
        showAddGoods() {
            this.$refs.refCreateOrEditGoods.dialogVisible = true;
        },
        // 显示添加品牌弹窗
        showAddProduct() {
            this.$refs.refCreateBrand.bindData();
        },
        // 未读数
        getReadCount() {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                size: 0, //页大小
                page: 0, //页数
                is_read: 0,
            };
            this.getReporCompeteProduct(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.$nextTick(() => {
                        this.unread_count = data.data.count;
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取表格数据  竞品列表/竞品预警
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                brand_id: this.formInline.product_id == 0 ? null : this.formInline.product_id,
                id: this.formInline.id,
                product_name: this.formInline.goods_name,
                size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
            };
            let url;
            if (this.activeName == 0) {
                url = this.getReporCompeteProduct;
            } else {
                url = this.competeProduct;
            }
            url(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        // 搜索
        onSubmit() {
            this.getList(1);
        },
        //重置
        reset() {
            this.formInline = {
                type: "0",
                data: "",
            };
            this.getList(1);
        },
        handleClick() {
            this.tableData = [];
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.dot {
    ::v-deep .el-badge__content.is-dot {
        left: -24px;
        top: 10px;
    }
}

.tabs {
    ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: -10px;
    }
}
::v-deep .el-tabs__item {
    padding: 0 30px;
}
</style>